module.exports = __webpack_public_path__ + "static/media/Valentines Day Menu.ad23ab3a.jpg";